import * as React from 'react';

import { Button, Margin, Size, Width } from '../Button';
import { Close, Icon, PlusCircled } from '../Icon';

import * as logger from '../../logger';

import styles from './MultiString.module.css';

interface Props {
  value: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
}
interface LocalState {
  values: string[];
  inputValue: string;
}

export class MultiString extends React.Component<Props, LocalState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      inputValue: '',
      values: [],
    };
  }

  parseValue = (value: string): string[] => {
    let values: string[] = [];
    if (value) {
      values = JSON.parse(value);
    }
    return values;
  };

  updateInputValue = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({
      inputValue: event.currentTarget.value,
    });
  };

  addValue = async (event: React.FormEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    const { inputValue } = this.state;
    if (!inputValue) {
      return;
    }
    const { value, updateFieldValue, saveFieldValue } = this.props;
    const values = this.parseValue(value);
    const updatedValues = [...values, inputValue];
    const valuesStr = JSON.stringify(updatedValues);
    updateFieldValue(valuesStr);
    await saveFieldValue(valuesStr);
    this.setState({
      inputValue: '',
    });
  };

  removeValue = async (indexToRemove: number) => {
    const { value, updateFieldValue, saveFieldValue } = this.props;
    const values = this.parseValue(value);
    const updatedValues = values.filter((v, i) => indexToRemove !== i);
    const valuesStr = JSON.stringify(updatedValues);
    updateFieldValue(valuesStr);
    await saveFieldValue(valuesStr);
  };

  render() {
    const { value } = this.props;
    let values: string[];
    try {
      values = this.parseValue(value);
    } catch (err) {
      logger.error(err, 'failed to parse list of values for MULTI_STRING');
      return null;
    }

    return (
      <div>
        {values.map((v, i) => (
          <div key={`${i}-${v}`} className={styles.ValueWrapper}>
            <span className={styles.Value}>{v}</span>
            <Icon
              className={styles.DeleteIcon}
              icon={Close}
              size={1}
              color={'#000000'}
              onClick={() => this.removeValue(i)}
            />
          </div>
        ))}
        <div className={styles.AddValueWrapper}>
          <input
            className={styles.Input}
            type="text"
            value={this.state.inputValue}
            onChange={this.updateInputValue}
          />
          <Button
            size={Size.Small}
            width={Width.Default}
            margin={Margin.None}
            onClick={this.addValue}
          >
            <Icon
              className={styles.AddIcon}
              icon={PlusCircled}
              size={1}
              color={'#ffffff'}
            />
          </Button>
        </div>
      </div>
    );
  }
}
